module.exports = "/_next/static/images/anchor-33d796a6200239f91d38cd65a2595c01.svg";